import { useLanguage } from '@/contexts/LanguageContext';
import { OrgAlert } from '@/components/common/OrgAlert';
import { SubscribeButton } from '@/components/billing/SubscribeButton';

/**
 * Alert content displayed when an organization has no active entitlements.
 * Shows an error alert prompting the user to subscribe.
 */
export function NoEntitlementsAlertContent() {
  const { t } = useLanguage();

  return (
    <OrgAlert variant="error" title={t.billing.noEntitlementsAlert.alertTitle}>
      <p className="text-xs">{t.billing.noEntitlementsAlert.description}</p>
      <div className="mt-auto self-end">
        <SubscribeButton
          variant="outline"
          size="sm"
          className="border-error text-error hover:opacity-90"
        />
      </div>
    </OrgAlert>
  );
}
